<lum-df-group [model]="model" [group]="group" [options]="options" [data]="data"> </lum-df-group>
